export type PromoErrorCode =
  | 'PROMO_NOT_FOUND'
  | 'PROMO_NOT_STARTED'
  | 'PROMO_EXPIRED'
  | 'PROMO_USER_LIMIT_REACHED'
  | 'PROMO_AUDIENCE_MISMATCH'
  | 'PROMO_NO_ELIGIBLE_ITEMS'

export interface PromoValidateItem {
  productId: string
  unitPrice: number
  quantity: number
}

export interface PromoValidateRequest {
  code: string
  items: PromoValidateItem[]
}

export interface PromoValidateResponse {
  valid: boolean
  errorCode?: PromoErrorCode
  amount: number
  eligibleAmount: number
  discountAmount: number
  grandTotalAmount: number
}

export interface AppliedPromo {
  code: string
  amount: number
  eligibleAmount: number
  discountAmount: number
  grandTotalAmount: number
}

export class PromoApiError extends Error {
  errorCode: PromoErrorCode | string
  status: number

  constructor(errorCode: PromoErrorCode | string, status: number, message?: string) {
    super(message || errorCode)
    this.name = 'PromoApiError'
    this.errorCode = errorCode
    this.status = status
  }
}

export const getPromoErrorMessage = (errorCode?: string): string => {
  switch (errorCode) {
    case 'PROMO_NOT_FOUND':
      return 'Такого промокоду не знайдено або він більше не діє'
    case 'PROMO_NOT_STARTED':
      return 'Цей промокод ще не активний. Спробуйте пізніше'
    case 'PROMO_EXPIRED':
      return 'На жаль, цей промокод вже не діє'
    case 'PROMO_USER_LIMIT_REACHED':
      return 'Ви вже використали цей промокод максимальну кількість разів'
    case 'PROMO_AUDIENCE_MISMATCH':
      return 'Цей промокод не застосовується до обраного Вами типу замовлення'
    case 'PROMO_NO_ELIGIBLE_ITEMS':
      return 'У кошику немає товарів, на які діє цей промокод'
    default:
      return 'Не вдалося застосувати промокод. Спробуйте ще раз'
  }
}
